export const commonExport = function (fileName, data){
    let anchor = document.createElement("a");
    anchor.setAttribute("download", fileName);
    anchor.setAttribute("href", data.data);
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
}